import React from "react"
import { Page } from "react-onsenui";
import styles from './index.module.css'
import inlineStyles from "./inlineStyles";
import { IconX } from "@tabler/icons-react";
import { useShowValidationResult } from "./useShowValidationResult";

const InvalidTicketResult = (props) => {

    const {scan, onClickNext} = props
    const {setShowValidationResult} = useShowValidationResult()

    return (
        <>
            <Page contentStyle={inlineStyles.modalBody} class={styles.invalid}>

                <div className={styles.card}>

                    <div className={styles.indicator}>
                        <IconX size={70}/>
                    </div>

                    <div className={styles.ticket}>
                        Invalid Ticket
                    </div>

                    <div className={styles.code}>
                        {scan.qr_data}
                    </div>

                </div>

                <button
                    className={styles.nextButton}
                    onClick={() => {
                      setShowValidationResult(false)
                      onClickNext()
                    }}
                >
                    Next
                </button>

            </Page>
        </>
    )
}

export default InvalidTicketResult
